import { Component, Input } from '@angular/core';
import {faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
@Component({
  selector: 'app-items-not-found',
  imports: [FontAwesomeModule],
  templateUrl: './items-not-found.html',
  styleUrl: './items-not-found.scss'
})
export class ItemsNotFound {
  @Input() title = 'Items not found';
  @Input() description = 'No data available at the moment.';
  @Input() icon: IconDefinition = faBoxOpen; 
}
